module.exports = __webpack_public_path__ + "static/media/tier-3.c4d6a438.jpg";